<button mat-raised-button [color]="config.color" (click)="open()">{{config.text}}</button>